import messages from './messages';
import polyglotI18nProvider from 'ra-i18n-polyglot';

const i18nProvider = polyglotI18nProvider(() => messages, 'pt');
export default i18nProvider;